import { getTimezoneOffset } from '../utils/timezone';
import api from './config';

export const startTimer = async (activityId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.post(`/activity/${activityId}/log/start`, {}, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.status === 200;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const stopTimer = async (activityId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.post(`/activity/${activityId}/log/stop`, {}, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.status === 200;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getActivityLogs = async (activityId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get(`/activity/${activityId}/log`, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteLog = async (activityId, logId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.delete(`/activity/${activityId}/log/${logId}`, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        if (response.status !== 200) {
            throw new Error(response.message || 'Failed to delete log');
        }
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const createLog = async (activityId, { fromDateTime, toDateTime }) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.post(`/activity/${activityId}/log`, {
            fromDateTime: formatDateTimeWithTz(fromDateTime),
            toDateTime: formatDateTimeWithTz(toDateTime)
        }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateLog = async (activityId, logId, { fromDateTime, toDateTime }) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.put(`/activity/${activityId}/log/${logId}`, {
            fromDateTime: formatDateTimeWithTz(fromDateTime),
            toDateTime: formatDateTimeWithTz(toDateTime)
        }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

const formatDateTimeWithTz = (date) => {
    const tzOffset = -getTimezoneOffset();
    const tzHours = Math.floor(Math.abs(tzOffset) / 60).toString().padStart(2, '0');
    const tzMinutes = (Math.abs(tzOffset) % 60).toString().padStart(2, '0');
    const tzString = `${tzOffset >= 0 ? '+' : '-'}${tzHours}:${tzMinutes}`;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${tzString}`;
};